import styled from "@emotion/styled";
export const StyledSquareTagsGridComponent = styled.div``;
